import type { FirebaseOptions } from '@angular/fire/app';

import { MatomoConfig } from './model/matomo';

export class DmbEnvironment {
  constructor(
    public readonly stage: 'prod' | 'dev' | 'staging' = 'dev',
    public readonly production = true,
    public readonly sentryDsn: string | null = null,
    public readonly firebaseConfig: FirebaseOptions = {},
    public readonly matomoConfig: MatomoConfig = {},
    public readonly v2Target: string,
    private readonly path = '/v5',
    private win: Window = window,
  ) {}

  v5Path(isSocket = false) {
    const loc = this.win.location;
    const uri = isSocket ? (loc.protocol === 'https:' ? 'wss:' : 'ws:') : loc.protocol;
    const port = loc.port == '' ? '' : `:${loc.port}`;
    return `${uri}//` + loc.hostname + port + this.path;
  }
}
